import type { ArrowDescriptor } from './arrows';
import type { DelineatorLine } from './delineators';

// Road overlay settings
export interface RoadOverlaySettings {
  enabled: boolean;
  showOnlyNearSigns: boolean;
}

// Default road overlay settings
export const DEFAULT_ROAD_OVERLAY_SETTINGS: RoadOverlaySettings = {
  enabled: false,
  showOnlyNearSigns: false,
};

// Unified selection state for the Properties Panel
export type SelectedElement = 
  | { type: 'sign'; id: string; data: any }
  | { type: 'arrow'; id: string; data: ArrowDescriptor }
  | { type: 'delineator'; id: string; data: DelineatorLine }
  | { type: 'workzone'; id: string; data: any }
  | { type: 'boundingbox' }
  | { type: 'roadoverlay'; data: RoadOverlaySettings }
  | null;

// Props for the Properties Panel
export interface PropertiesPanelProps {
  selectedElement: SelectedElement;
  onClose: () => void;
  // Sign handlers
  onSignRotate?: (id: string, rotation: number) => void;
  onSignResize?: (id: string, scale: number) => void;
  onSignMove?: (id: string, position: { lat: number; lng: number }) => void;
  onSignCalloutMove?: (id: string, offset: { x: number; y: number }) => void;
  onSignDelete?: (id: string) => void;
  // Arrow handlers
  onArrowDistanceChange?: (id: string, distance: number) => void;
  onArrowLabelVisibilityChange?: (id: string, show: boolean) => void;
  onArrowDelete?: (id: string) => void;
  // Delineator handlers
  onDelineatorUpdate?: (id: string, updates: Partial<DelineatorLine>) => void;
  onDelineatorDelete?: (id: string) => void;
  // Workzone handlers
  onWorkzoneDelete?: (id: string) => void;
  // Bounding box handlers
  onPaperSizeChange?: (size: string, orientation: string) => void;
  onMapFadeChange?: (opacity: number) => void;
  // Road overlay handlers
  onRoadOverlaySettingsChange?: (settings: Partial<RoadOverlaySettings>) => void;
}
